module.exports = __webpack_public_path__ + "img/thumb_19.d3e0e0bb.jpg";